import { Component, Input, Output, EventEmitter } from '@angular/core';
import { NotificationsService } from 'angular2-notifications';
import 'rxjs/add/operator/finally';

import { Subscription } from '../../../entities/index';
import { SubscriptionService } from '../../../services/subscription.service';
import { Log } from '../../../utils/index';

@Component({
  selector: 'app-subscription-information',
  templateUrl: './subscription-information.html'
})
export class SubscriptionInformationComponent {
  loading = false;

  @Input()
  subscription: Subscription = null;

  @Output()
  subscriptionChange: EventEmitter<Subscription> = new EventEmitter<Subscription>();

  constructor(protected subscriptionService: SubscriptionService,
              protected notification: NotificationsService) {
  }

  @Log('blue')
  save() {
    this.subscriptionService
      .put_modify_next_charge_at(this.subscription.id, this.subscription.next_charge_at.toISOString())
      .subscribe(subscription => {
        this.subscription = subscription,
        this.notification.success('SUCCESS', 'The next charge at has been updated.');
      });
  }

  @Log('blue')
  cancelSubscription() {
    if (confirm('Are you sure you want to cancel this subscription ?')) {
      const subscriptionId = this.subscription.id;
      this.loading = true;
      this.subscriptionService
        .cancel(this.subscription)
        .finally(() => this.loading = false)
        .subscribe(succ => {
          this._loadSubscription(subscriptionId);
          this.notification.success('SUCCESS', 'The subscription is canceled');
        });
    }
  }

  @Log('blue')
  reactivateSubscription() {
    if (confirm('Are you sure you want to reactivate this subscription ?')) {
      const subscriptionId = this.subscription.id;
      this.loading = true;
      this.subscriptionService
        .reactivate(this.subscription)
        .finally(() => this.loading = false)
        .subscribe(succ => {
          this._loadSubscription(subscriptionId);
          this.notification.success('SUCCESS', 'The subscription is reactivated');
        });
    }
  }

  @Log('blue')
  cancelSubscriptionImmediately() {
    if (confirm('Are you sure you want to cancel immediately this subscription ?')) {
      const subscriptionId = this.subscription.id;
      this.loading = true;
      this.subscriptionService
        .cancel_immediately(this.subscription)
        .finally(() => this.loading = false)
        .subscribe(succ => {
          this._loadSubscription(subscriptionId);
          this.notification.success('SUCCESS', 'The subscription is canceled immediately');
        });
    }
  }

  _loadSubscription(subscriptionId: number) {
    this.subscriptionService
      .get(subscriptionId)
      .subscribe(subscription => {
        this.subscription = subscription;
        this.subscriptionChange.emit(subscription);
      });
  }
}



// WEBPACK FOOTER //
// /app/src/app/components/blocks/subscription-information/subscription-information.component.ts